export let getParentNames = ({ def }) => { // links and subgroup links
  return def.links.reduce((acc, val) => val.subgroup
    ? [ ...acc, ...val.subgroup.map(x => x.target_type) ]
    : [ ...acc, val.target_type ]
  , []);
};

export let getDefsWithParents = ({ defs }) => {
  return defs.filter(def => def.links && def.links.length)
    .map(def => ({
      parents: getParentNames({ def }),
      entity: def.id
    }));
};

export let sortByYoungest = ({ defsWithParents }) => {
  let originalLength = defsWithParents.length;
  return (function sort({ defsWithParents, result = [] }) {
    if (result.reduce((p, c) => [...p, ...c], []).length === originalLength) return result;

    let youngest = defsWithParents.filter(def =>
      defsWithParents.filter(x => x.entity !== def.entity)
        .every(x => !x.parents.includes(def.entity))
    );

    return sort({
      defsWithParents: defsWithParents.filter(def =>
        !youngest.some(x => x.entity === def.entity)
      ),
      result: [ youngest, ...result ]
    });
  }({ defsWithParents }));
};
